import type { UserInfo } from './types';

export interface MePermissionsResponse {
  roles: string[];
  permissions: string[];
  scopes: Record<string, string>;
  isPlatformAdmin: boolean;
}

export function hasPermission(
  user: UserInfo | null | undefined,
  permissionId: string
): boolean {
  if (!user || !permissionId) return false;
  return (user.permissions ?? []).some(
    p => p.toLowerCase() === permissionId.toLowerCase()
  );
}

export function hasAnyPermission(
  user: UserInfo | null | undefined,
  permissionIds: string[]
): boolean {
  return permissionIds.some(id => hasPermission(user, id));
}

export function getPermissionScope(
  user: UserInfo | null | undefined,
  permissionId: string
): string | undefined {
  if (!user?.scopes) return undefined;
  const match = Object.keys(user.scopes).find(
    key => key.toLowerCase() === permissionId.toLowerCase()
  );
  return match ? user.scopes[match] : undefined;
}
